import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { EnumLegalInjectionToken, EnumLegalPageRoute, ILegalPagesConfig } from './legal-pages.interface';


@Injectable()
export class LegalPagesRouteService {

	constructor(
		@Inject(EnumLegalInjectionToken.Config)
		public  config: ILegalPagesConfig,
		private router: Router
	) { }

	//** Can a route be allowed or not */
	canActivateLegalPageRoute(route: ActivatedRouteSnapshot): boolean {

		//0 - check whether the path is included in disabled page
		const isPageDisabled: boolean = this.config.disabledPages.includes((route.routeConfig?.path!) as EnumLegalPageRoute);

		//1 - if page is not disabled then continue showing the page
		if (!isPageDisabled) return !isPageDisabled;

		//2 - if page disabled then show page not found component
		this.router.navigate(['not-found']);
		return false;
	}
}
